import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import { ActivatedRoute, Router } from "@angular/router";

import { ProfissionalService } from '../services/profissional.service';
import { TipoProfissionalService } from '../services/tipo-profissional.service';
import { ExcelService } from '../services/excel.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { UnidadeService } from '../services/unidade.service';
import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';

import { PerfilUsuarioService } from '../services/perfil-usuario.service';



@Component({
	selector: 'app-profissionais',
	templateUrl: './profissionais.component.html',
	styleUrls: ['./profissionais.component.css'],
	animations: [loadingFade, modal, alert]
})
export class ProfissionaisComponent implements OnInit {
	public loading = false;
	public profissionais = [];
	public perfil = this.authSvc.getPerfil();

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public tiposProfissional = [];
	public formFiltro: FormGroup;
	public showFilter = true;
	public unidades = [];
	public clientes = [];
	public usuario_perfil;

	//acesso
	public menu_id = 126; //Cadastro - ADM
	public visualizar = true;
	public editar = false;		

	constructor(private fb: FormBuilder,
				private profissionalSvc: ProfissionalService,
				private tipoProfissionalSvc: TipoProfissionalService,
				private unidadeSvc: UnidadeService,
				private authSvc: AuthService,
				private clienteSvc: ClienteService,
				private route: ActivatedRoute,
				private router: Router,	
				private excelSvc: ExcelService,
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		this.criaFiltro();

		this.pegaClientes();


		if(this.usuario_perfil == 13){ 
			//Perfil com Unidades que o usuario pode ver
			this.pegaProfissinaisPorUnidades()
		}else{
			this.pegaProfissinais();
		}

		
		this.pegaTiposProfissional();
	}

	pegaProfissinais() {
		this.profissionalSvc.getProfissionais().then((data: any) => {
			this.profissionais = data;
			this.count = this.profissionais.length;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaProfissinaisPorUnidades() {
		this.profissionalSvc.getProfissionalPorUnidade(this.authSvc.getUsuarioId()).then((data: any) => {
			this.profissionais = data;
			this.count = this.profissionais.length;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaTiposProfissional() {
		this.tipoProfissionalSvc.getTiposProfissional().then((data: any) => {
			this.tiposProfissional = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaProfissional(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente Inativar este Profissional?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.profissionalSvc.apagaProfissional(id).then((data) => {
					this.pegaProfissinais();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel() {
		let data = [];
		if (this.dadosFiltrados.length == 0) {
			this.dadosFiltrados = this.profissionais;
		}
		for (let index in this.dadosFiltrados) {
			data[index] = {
				'Nome': this.dadosFiltrados[index].profissional_nome,
				'CPF': this.dadosFiltrados[index].profissional_cpf,
				'RG': this.dadosFiltrados[index].profissional_rg,
				'CNH': this.dadosFiltrados[index].profissional_cnh,
				'E-mail': this.dadosFiltrados[index].profissional_email,
				'Data Nasc.': this.dadosFiltrados[index].profissional_data_nascimento,
				'Telefone': this.dadosFiltrados[index].profissional_telefone_residencial,
				'Celular': this.dadosFiltrados[index].profissional_telefone_celular,
				'Situação': this.dadosFiltrados[index].profissional_situacao == 1 ? 'Ativo' : 'Inativo'
			};
		}

		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Profissionais');
	}

	criaFiltro() {
		this.formFiltro = this.fb.group({
			profissional_nome___nome: '',
			tipo_profissional_id___tipo: null,
			cliente_id___cliente: null,
			unidade_id___unidade: null,
			profissional_situacao___situacao: null
		});


		this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loCliente_id = null;
			  let loUnidade_id = null;
			  let loNome = null;
			  let loTipo = null;
			  let loStatusU = null;
	  
			  this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "cliente_id___cliente": { 
	  
					if(loSplitValor[1] !== "null"){
					  loCliente_id = parseInt(loSplitValor[1]);
					  this.pegaUnidadesFiltro(loSplitValor[1]);
					}
					 break; 
	  
				  } 
				  case "unidade_id___unidade": { 
					if(loSplitValor[1] !== "null"){
					  loUnidade_id = parseInt(loSplitValor[1]);
					}
	  
					break; 
				  }
				  case "profissional_nome___nome": { 
					if(loSplitValor[1] !== "null"){
					  loNome = loSplitValor[1];
					}
					break; 
				  }  
				  case "tipo_profissional_id___tipo": { 
					if(loSplitValor[1] !== "null"){
						 loTipo =  parseInt(loSplitValor[1]);
					}
					 break; 
				  }   
				  case "profissional_situacao___situacao": { 
					if(loSplitValor[1] !== "null"){
						 loStatusU =  loSplitValor[1];
					}
					 break; 
				  } 				                                                     
				 }
	  
			  }
			  this.preencheForm({
				cliente_id___cliente: loCliente_id,
				unidade_id___unidade: loUnidade_id,
				profissional_nome___nome: loNome,
				tipo_profissional_id___tipo: loTipo, 
				profissional_situacao___situacao: loStatusU
			  });
			  this.filtra();
	  
			}
	  
		  });


	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
	}

	pegaUnidadesFiltro(cliente_id){
		if(cliente_id){
		  this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
			this.unidades = data;
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
			this.loading = false;
		  });
		}
	  }


	filtra() {
		this.filtro = this.formFiltro.value;


		this.dadosFiltrados = new FiltroPipe().transform(this.profissionais, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
	}

	expandPanel() {
		this.showFilter = this.showFilter == true ? false : true;
	}

	nivel(validade, pontos){
		let data_atual = moment().format('YYYY-MM-DD');
		
		if((moment(validade).isAfter(data_atual) == false) || pontos > 20){
			return 'vencido';
		}
		else if(pontos >= 15){
			return 'proximo';
		}
		else{
			return 'onTime';
		}
	}

	onChangeCliente(evento) {
		this.formFiltro.controls.unidade_id___unidade.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
		  this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  pegaClientes() {
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.clientes = data;
		});
	  }

	  onClickLimparCampos(){
		this.formFiltro = this.fb.group({
			profissional_nome___nome: '',
			tipo_profissional_id___tipo: null,
			cliente_id___cliente: null,
			unidade_id___unidade: null,
			profissional_situacao___situacao: null
		});
	  }


	  EditProfissional(profissional_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		this.router.navigate(['home/profissionais/edit/' + profissional_id + params]);
	  }
	
	
	 
}
